import urlSafeBase64 from 'helpers/urlSafeBase64';
import { snapWidth } from 'helpers/imageWidths';
import { ROOTURL } from '../config';

const imgProxyLoader = ({
  src,
  width: rawWidth,
  // quality,
}) => {
  // Snap to the canonical ladder so responsive srcset entries collapse onto a
  // few shared derivatives (deviceSizes already feeds canonical widths; this
  // also catches explicit widths). We request width only and let CSS
  // object-cover frame each box, so every surface that shows a given image at a
  // given width reuses the one proportional derivative.
  const width = snapWidth(rawWidth);
  const isLocal = src.startsWith('/');
  if (isLocal) {
    // Static assets are resized through the truvvle proxy too — /_next/image
    // is unused by design (no sharp on the server). The proxy can't reach
    // localhost, so dev builds serve the raw file.
    if (!ROOTURL || ROOTURL.includes('//localhost')) return src;
    return `https://img.truvvle.com/?src=${urlSafeBase64(
      ROOTURL + src,
    )}&width=${width}`;
  }

  // Already proxied: swap the sizing params instead of wrapping the proxy
  // URL in itself (double-encoding breaks resizing and serves huge files).
  if (src.startsWith('https://img.truvvle.com/')) {
    try {
      const proxied = new URL(src);
      proxied.searchParams.set('width', width);
      proxied.searchParams.delete('height');
      return proxied.toString();
    } catch {
      return src;
    }
  }

  const encodedURL = urlSafeBase64(src);

  return 'https://img.truvvle.com/?src=' + encodedURL + '&width=' + width;
};

module.exports = imgProxyLoader;
